import { environmentHttpClient } from "client/Api/httpClient";
import { SignatureKind } from "../../common";

export interface SignatureConstraints {
	supportedImageTypes: string[];
	maxFileSize: number;
}

export interface PersonalSignatureModel {
	isEnabled: boolean;
	content: string | null;
}

export interface ConfigurePersonalSignatureModel {
	defaultSignature: SignatureKind;
	personalSignature: PersonalSignatureModel;
}

export interface AvailableSignature {
	kind: SignatureKind;
	name: string;
}

export interface EditPersonalSignatureViewModel {
	signatureConstraints: SignatureConstraints;
	availableSignatures: readonly AvailableSignature[];
	hasEnforcedManagedSignature: boolean;
	defaultSignatureKind: SignatureKind;
	personalSignature: PersonalSignatureModel;
}

export function getViewModel(
	signal?: AbortSignal
): Promise<EditPersonalSignatureViewModel> {
	return environmentHttpClient.get<EditPersonalSignatureViewModel>(
		"/email/signature/personal/viewmodel",
		undefined,
		{ signal }
	);
}

export function save(
	model: ConfigurePersonalSignatureModel,
	signal?: AbortSignal
): Promise<ConfigurePersonalSignatureModel> {
	return environmentHttpClient.put<ConfigurePersonalSignatureModel>(
		"/email/signature/personal",
		model,
		{ signal }
	);
}